import { useContext} from "react";
import { WebContext } from "../Utility";
import LocalStorage from "../LocalStorage";
const useMemeberInfo = () => {
  const websiteContext = useContext(WebContext) || {};
  const user = LocalStorage?.getUser() || {};
  const {username = null,lmsOrgCode = '',memberCode = '',isLoggedIn = false ,memberProfile = {}}  = websiteContext;
  
  return {username,lmsOrgCode,memberCode,user,isLoggedIn ,memberProfile};
};

export default useMemeberInfo;
